import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.network.dns.domain.disablePrivacy;

const { actions, reducer, sagas, selectors } = createAPIModule({
	getStateSlice,
	actionType: 'NETWORK_DNS_DOMAIN_DISABLEPRIVACY',
	method: 'POST',
	url: '/network/dns/domain/disablePrivacy.json',
});

export { actions, reducer, sagas, selectors };
